import { Box, Button, Link, Typography } from '@mui/material';
import { noop } from 'lodash';
import React, { FC } from 'react';

interface IHomeItemProps {
	itemKey: string;
	url?: string;
	onClick?: () => void;
	icon: React.ReactNode;
	size?: 'small' | 'large';
}

const HelpItem: FC<IHomeItemProps> = ({
	itemKey,
	url,
	onClick,
	icon,
	size
}) => {
	const props = url ? { href: url, target: '_blank' } : { onClick };

	return (
		<Button
			sx={{
				display: 'flex',
				flexDirection: 'column'
			}}
		>
			<Link
				{...props}
				pl={1}
				underline="none"
				color="default"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					textAlign: 'left'
				}}
			>
				<Box display="flex" flexDirection="row">
					<Box display="flex" flexDirection="row" alignItems="center" pr={1}>
						{icon}
					</Box>
					<Typography
						variant={size === 'small' ? 'body1' : 'h5'}
						textTransform="uppercase"
						display="flex"
						flexDirection="row"
						data-testid="home-footer-header"
						sx={{
							wordBreak: 'break-word'
						}}
					>
						{intl.tr(`home.footer.item.${itemKey}.header`)}
					</Typography>
				</Box>
				<Box pt={1}>
					<Typography
						variant={size === 'small' ? 'body2' : 'body1'}
						color="text.secondary"
						data-testid="home-footer-subtitle"
					>
						{intl.tr(`home.footer.item.${itemKey}.subHeader`)}
					</Typography>
				</Box>
			</Link>
		</Button>
	);
};

HelpItem.defaultProps = {
	url: '',
	onClick: noop,
	size: 'large'
};

export default HelpItem;
